import { Collapse, Stack, Typography } from "@mui/material";
import { TEXT_TERTIARY } from "@/config/mui/colorPalette";
import PackageItemLine, { PackageItemLineType } from "./oldPackageItemLine";

type PackageItemLinesProps = {
  items: PackageItemLineType[];
  isFocused: boolean;
  isMobile: boolean;
};

export default function PackageItemLines({
  items,
  isFocused,
  isMobile,
}: PackageItemLinesProps) {
  const packageItemLineSize = isMobile ? "medium" : "small";

  return (
    <Stack>
      {items.slice(0, 2).map((item) => (
        <PackageItemLine key={item.id} item={item} size={packageItemLineSize} />
      ))}
      {items.length > 2 && (
        <Stack>
          <Collapse in={isFocused}>
            {items.slice(2).map((item) => (
              <PackageItemLine
                key={item.id}
                item={item}
                size={packageItemLineSize}
              />
            ))}
          </Collapse>

          <Collapse in={!isFocused}>
            <Typography
              variant={isMobile ? "labelSmall" : "labelTiny"}
              sx={{
                color: TEXT_TERTIARY,
              }}
            >
              +{items.length - 2} more
            </Typography>
          </Collapse>
        </Stack>
      )}
    </Stack>
  );
}
